import {useState, useEffect, useLayoutEffect} from "react";

interface Size {
  width: number;
  height: number;
}

type DetectedDevice = "mobile" | "tablet" | "laptop" | "fullHd" | "header-tablet";

export function useWindowSize() {
  const [size, setSize] = useState([0, 0]);
  useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);
  return size;
}

function useSizeWindow(): DetectedDevice {
  const [windowSize, setWindowSize] = useState<Size>({
    width: 0,
    height: 0,
  });
  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowSize && detectDevice(windowSize.width);
}

function detectDevice(windowWidth: number): DetectedDevice {
  if (windowWidth <= 570) {
    return "mobile";
  } else if (windowWidth <= 845) {
    return "tablet";
  } else if (windowWidth <= 775) {
    return "header-tablet";
  } else if (windowWidth <= 1440) {
    return "laptop";
  } else {
    return "fullHd";
  }
}

export default useSizeWindow;
